import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import { i18n } from 'i18n';
import * as parentConstants from 'modules/QAQC/QAQCAreaPage/constants';
import makePage from 'modules/makePage';
import * as constants from './constants';
import { NewBreakingSchedulePageParams } from './constants';

const NewBreakingSchedulePage = lazyWithSuspense(() => import('./NewBreakingSchedulePage'));

const page: Page<NewBreakingSchedulePageParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: false,
  component: makePage<NewBreakingSchedulePageParams>({
    WrappedPage: NewBreakingSchedulePage,
    titleFn: () => i18n._(constants.TITLE),
    parentPathTemplate: parentConstants.ACTIVE_POURS_ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.ACTIVE_POURS_TITLE),
  }),
};

export default page;
